module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD9SURBVDhPYxha4My7M/wnnp1IP/70ZDkxGKg2DaQHqh0VHH54WPD40xN3Tzw7+Z8UDNKD1VCQy7BpIAYDXZsKNQYBgIIV2BQTh0+0Q41BAFIM3HF/5//SQ5X/Dzw6BBWjwECQYdFb4//7bgj8v+TaMqg4mQaCDdsWBzZs9qW5SHIEDATG3P/5lxcgacBnGAgTMLDrVO9/n/UB/ztOdYP5O+/vwmMYEQaCAjt9TxbY0MZjLQQMA2EiwhDZUPyGgTCRkQIyNGNPDgHDQJhIA0EYFEHYxFExdgNTsSsmjEF6ocYgwPn75wWoWjiAALT4SgPiDmIwyGU4DRukgIEBAFuLLjoJ3fRJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/tick_icon.png
// module id = 50
// module chunks = 0